export const SuppliersBaseRoute = '/products/suppliers';
